import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadersCheckmarkModule } from './loadersCheckmark';
import { LoadersErrorModule } from './loadersError';
import { LoadersTypesModule } from './loadersTypes';

import { LoadersComponent } from './loaders.shared.component';

const toExport: any[] = [
    LoadersCheckmarkModule,
    LoadersErrorModule,
    LoadersTypesModule,
];

@NgModule({
    declarations: [
        LoadersComponent
    ],
    imports: [
        CommonModule,
        ...toExport,
    ],
    exports: [
        LoadersComponent,
        ...toExport,
    ],
    providers: [],
})
export class LoadersModule { }
